import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';

export const useProcId = () => {
  const { state } = useLocation();
  const { procId } = useParams();

  return useMemo(() => state?.procId || procId, [state, procId]);
};
